import Typography from 'typography'
import Wordpress2016 from 'typography-theme-wordpress-2016'

Wordpress2016.overrideThemeStyles = () => {
  return {
    '*': {
      fontFamily: 'Segoe UI,SegoeUI,Helvetica Neue,Helvetica,Arial,sans-serif !important',
    },
    'a.gatsby-resp-image-link': {
      boxShadow: `none`,
    },
    'a.linkWithoutDecoration': {
      boxShadow: `none`,
      textDecoration: `none`,
      color: `inherit`,
    },
    // font-size: 3.95285rem; line-height: 4.375rem; margin-bottom: 2.625rem; margin-top: 0px;
  }
}

delete Wordpress2016.googleFonts

const typography = new Typography(Wordpress2016)

// Hot reload typography in development.
if (process.env.NODE_ENV !== `production`) {
  typography.injectStyles()
}

export default typography
export const rhythm = typography.rhythm
export const scale = typography.scale
